import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { colors } from "../../Assets/styles/colors";
import { useTranslate } from '@tolgee/react';
import { useConversationService } from "../../Context/ConversationsContext";
import { useAuthService } from "../../Context/AuthContext";
import ContactElementChatDetails from "../Chat/ChatDetailsContactElement";
import AddMembers from "../NewGroup/AddMembers";
import PrimaryButton from "../GenericComponents/PrimaryButton";
import PrimaryButtonRemove from "../GenericComponents/PrimaryButtonRemove";
import { ADD_MEMBERS, NEW_CONTACT, SELECTED_MEMBERS } from "../../Constants/constantValues";
import AddNewChatContact from "../Contacts/AddNewContact";
import { useNotify } from "../../Helpers/Notifications";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import { ReactComponent as PlusIcon } from "../../Assets/icons/PlusIcon.svg";
import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg";
import { ReactComponent as LeaveGroupIcon } from "../../Assets/icons/logoutIcon.svg";
import { Item, Menu, useContextMenu } from "react-contexify";
import DeleteConfirmationChild from "../GenericComponents/DeleteConfirmationChild";
import { displayAvatar } from "../../Helpers/chatHelper/AvatarHelper";

const CustomItem = ({ text, icon, redButton }) => {
  return (
    <CustomItemContainer redButton={redButton}>
      <p>{text}</p>
      {icon}
    </CustomItemContainer>
  );
};

const CallChatDetailsView = ({
  conversationData,
  setConversations,
  setSelectedConversation,
  contacts,
  setLoading,
  loadContacts,
  handleInviteContact,
}) => {
  const {
    removeGroupMember,
    addGroupMember,
    makeGroupAdmin,
    removeGroupAdmin,
    updateGroup,
  } = useConversationService();
  const { notifySuccess, notifyError } = useNotify();
  const { setShowGroupChatDetails } = useGenericComponentsStateService();
  const { user } = useAuthService();
  const { t } = useTranslate();

  const profileAvatarRef = useRef();
  const [selectedContacts, setSelectedContacs] = useState([]);
  const [initialContacts, seInitialContacts] = useState([]);
  const [option, setOption] = useState(SELECTED_MEMBERS);
  const [removeUserConfirmation, setRemoveUserConfirmation] = useState(false);
  const [revokeAdminConfirmation, setRevokeAdminConfirmation] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isCurrentUserAdmin, setIsCurrentUserAdmin] = useState(false);
  const [memberCount, setMemberCount] = useState(0);
  const [isCallActive, setIsCallActive] = useState(false);
  const [previewAvatar, setPreviewAvatar] = useState();
  const [avatar, setAvatar] = useState();
  const [groupName, setGroupName] = useState("");
  const [infoChanged, setInfoChanged] = useState(false);

  const buttonList = [
    {
      id: "make_admin",
      text: t('chat_details.make_admin'),
    },
    {
      id: "revoke_admin",
      text: t('chat_details.revoke_admin'),
      redButton: true,
      withConfirmation: true
    },
    {
      id: "remove_user",
      text: t('chat_details.remove_user'),
      redButton: true,
      withConfirmation: true
    },
  ];

  const MENU_ID = "callChatDetailsMenu-id";

  const { show } = useContextMenu({
    id: MENU_ID,
  });

  function displayMenu(e, user) {
    setSelectedMember(user);
    show({
      event: e,
    });
  }

  function handleItemClick({ id }) {
    switch (id) {
      case "make_admin":
        handleMakeAdmin(selectedMember);
        break;
      case "revoke_admin":
        setRevokeAdminConfirmation(true);
        break;
      case "remove_user":
        setRemoveUserConfirmation(true);
        break;
      default:
        break;
    }
  }

  const checkIfUserIsAdmin = (contact) => {
    if (!contact || !conversationData?.admin_ids) {
      return false;
    }
    return conversationData.admin_ids.includes(contact.id);
  };

  const filterButtons = (buttons) => {
    let availableOptions = buttons;
    if (!user || !selectedMember) {
      return availableOptions;
    }

    const userIsAdmin = checkIfUserIsAdmin(selectedMember);

    if (selectedMember.id === user.id) {
      availableOptions = availableOptions.filter((item) => item.id !== "remove_user");
    }
    if (!userIsAdmin) {
      availableOptions = availableOptions.filter((item) => item.id !== "revoke_admin");
    }
    if (userIsAdmin) {
      availableOptions = availableOptions.filter((item) => item.id !== "make_admin");
    }

    return availableOptions;
  };

  const handleOpenAvatar = () => {
    profileAvatarRef.current.click();
  };

  const handleAvatarChange = (e) => {
    setAvatar(e.target.files[0]);
    setPreviewAvatar(URL.createObjectURL(e.target.files[0]));
  };

  const handleUpdateCallChat = () => {
    var objData = new FormData();

    objData.append("conversation_id", conversationData.id);
    objData.append("name", groupName);

    if (avatar) {
      objData.append("image", avatar);
    }

    updateGroup(
      objData,
      function (response) {
        let resp = response.data.conversation;
        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === resp.id) {
              return resp;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setSelectedConversation(resp);
        setInfoChanged(false);
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
      }
    );
  };

  const handleAddMember = (member, onSucces) => {
    addGroupMember(
      null,
      [member.id],
      function (response) {
        let res = response.data.conversation;
        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === res.id) {
              return res;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setSelectedConversation(res);
        if (onSucces) {
          onSucces();
        }
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
      },
      conversationData.id
    );
  };

  const handleRemoveMember = (member) => {
    removeGroupMember(
      null,
      [member.id],
      function (response) {
        let res = response.data.conversation;
        if (member.id === user.id) {
          setConversations((prev) => {
            let mapped = prev.filter((item) => item.id !== res.id);
            return mapped;
          });
          setSelectedConversation(null);
          setShowGroupChatDetails(false);
        } else {
          setConversations((prev) => {
            let mapped = prev.map((item) => {
              if (item.id === res.id) {
                return res;
              } else {
                return item;
              }
            });
            return mapped;
          });
          setSelectedConversation(res);
        }
      },
      function (error) {
        notifyError(`${t('general.something_wrong')}`);
      },
      conversationData.id
    );
  };

  const handleMakeAdmin = (member) => {
    setLoading(true);
    makeGroupAdmin(
      null,
      [member.id],
      (response) => {
        let res = response.data.conversation;
        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === res.id) {
              return res;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setLoading(false);
        setSelectedConversation(res);
      },
      (error) => {
        setLoading(false);
        notifyError(`${t('general.something_wrong')}`);
      },
      conversationData.id
    );
  };

  const handleRevokeAdmin = (member) => {
    setLoading(true);
    removeGroupAdmin(
      null,
      [member.id],
      (response) => {
        let res = response.data.conversation;
        setConversations((prev) => {
          let mapped = prev.map((item) => {
            if (item.id === res.id) {
              return res;
            } else {
              return item;
            }
          });
          return mapped;
        });
        setLoading(false);
        setSelectedConversation(res);
      },
      (error) => {
        setLoading(false);
        notifyError(`${t('general.something_wrong')}`);
      },
      conversationData.id
    );
  };

  const displaySortedParticipants = (user_list) => {
    let newUserList = user_list;
    let sortedParticipants = newUserList.sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
    return sortedParticipants;
  };

  const handleBackBtn = () => {
    setOption(SELECTED_MEMBERS);
    setSelectedContacs(initialContacts);
  };

  const handleSaveBtn = () => {
    const newToAdd = selectedContacts.filter(
      (selected) => !initialContacts.some((remove) => remove.id == selected.id)
    );

    for (let index = 1; index <= newToAdd.length; index++) {
      if (newToAdd.length > 1) {
        if (index == newToAdd.length) {
          notifySuccess(t('new_chat.members_added'));
          setOption(SELECTED_MEMBERS);
          return;
        }
        handleAddMember(newToAdd[index - 1], function () {
          handleAddMember(newToAdd[index]);
        });
      } else {
        handleAddMember(newToAdd[index - 1], function () {
          notifySuccess(t('new_chat.members_added'));
          setOption(SELECTED_MEMBERS);
        });
        return;
      }
    }
  };

  const handleSelectNewContact = (contact) => {
    let foundInSelected = selectedContacts.find(
      (item) => item.id === contact.id
    );
    let foundInInitial = initialContacts.find((item) => item.id === contact.id);

    if (foundInSelected) {
      if (foundInInitial) {
        return;
      }
      let filtered = selectedContacts.filter((item) => item.id !== contact.id);
      setSelectedContacs(filtered);
    } else {
      setSelectedContacs([...selectedContacts, contact]);
    }
  };

  const handleCloseAddNewContact = (item) => {
    setOption(ADD_MEMBERS);
  };

  const handleLeaveGroup = (user) => {
    setSelectedMember(user);
    setRemoveUserConfirmation(true);
  };

  const calculateMembers = () => {
    let found = conversationData.other_participants.find(
      (item) => item.id === user.id
    );
    var number = 0;
    if (!found) {
      number = conversationData.other_participants.length + 1;
    } else {
      number = conversationData.other_participants.length;
    }
    setMemberCount(number);
  };

  const checkChanges = () => {
    const originalImage = conversationData?.call_info?.image || null;
    const originalName = conversationData?.display_name || "";
    
    if (groupName !== originalName || previewAvatar !== originalImage) {
      setInfoChanged(true);
    } else {
      setInfoChanged(false);
    }
  };

  useEffect(() => {
    checkChanges();
  }, [groupName, previewAvatar]);

  useEffect(() => {
    if (conversationData?.call_info) {
      setIsCallActive(conversationData.call_info.is_active === true);
    }
  }, [conversationData?.call_info]);

  useEffect(() => {
    if (checkIfUserIsAdmin(user)) {
      setIsCurrentUserAdmin(true);
    } else {
      setIsCurrentUserAdmin(false);
    }
  }, [conversationData, conversationData?.admin_ids, user]);

  useEffect(() => {
    if (conversationData?.other_participants) {
      let sortedParticipants = displaySortedParticipants(
        conversationData.other_participants
      );
      seInitialContacts(sortedParticipants);
      setSelectedContacs(sortedParticipants);
      calculateMembers();
    }
    
    setGroupName(conversationData?.display_name || "");
    setPreviewAvatar(conversationData?.call_info?.image || null);
  }, [conversationData, conversationData?.other_participants?.length]);

  return (
    <AddNewGroupContainer>
      {option === ADD_MEMBERS && (
        <Wrapper>
          <AddMembers
            contacts={contacts}
            selectedContacts={selectedContacts}
            setSelectedContacs={setSelectedContacs}
            initialContacts={initialContacts}
            setOption={setOption}
            groupDetailsSide
            handleSelectContact={handleSelectNewContact}
            handleInviteContact={handleInviteContact}
            handleBackBtn={handleBackBtn}
            handleSaveBtn={handleSaveBtn}
          />
        </Wrapper>
      )}

      {option === SELECTED_MEMBERS && (
        <>
          <Group>
            <TitleWrapper>
              <h1>{t('chat_details.group_details')}</h1>
            </TitleWrapper>
            <OptionWrapper>
              <ProfileDetails>
                <UserWrapper>
                  <input
                    type="file"
                    hidden
                    accept=".png, .jpg, .jpeg"
                    ref={profileAvatarRef}
                    onChange={(e) => handleAvatarChange(e)}
                    onClick={(e)=>(e.target.value=null)}
                  />
                  <UserAvatarWrapper>
                    <UserAvatar onClick={!isCallActive ? handleOpenAvatar : undefined}>
                      {previewAvatar ? (
                        <PreviewAvatar>
                          <img src={previewAvatar} alt="avatar" />
                        </PreviewAvatar>
                      ) : (
                        displayAvatar(conversationData)
                      )}
                    </UserAvatar>
                    {!isCallActive && (
                      <EditButton onClick={handleOpenAvatar}>
                        {t('general.edit').toUpperCase()}
                      </EditButton>
                    )}
                  </UserAvatarWrapper>
                  <CustomNameInput 
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder={t('new_chat.enter_group_name')}
                    name="groupName"
                    maxLength={100}
                    readOnly={isCallActive}
                  />
                </UserWrapper>
              </ProfileDetails>
            </OptionWrapper>
          </Group>
          <Separator />
          
          {!isCallActive && isCurrentUserAdmin && (
            <Group>
              <TitleWrapper>
                <h1>{t('new_chat.add_members')}</h1>
              </TitleWrapper>
              <ChatOption style={{ flexDirection: "column" }}>
                <PrimaryButton
                  style={{ padding: "16px" }}
                  onClick={() => setOption(ADD_MEMBERS)}
                  iconLeft={<PlusIcon />}
                  text={t('new_chat.add_members')}
                />
              </ChatOption>
            </Group>
          )}

          {!isCallActive && (
            <Group>
              <ChatOption style={{ flexDirection: "column" }}>
                <DeleteConfirmationChild>
                  <PrimaryButtonRemove
                    style={{ padding: "16px" }}
                    onClick={(e) => handleLeaveGroup(user)}
                    iconLeft={<LeaveGroupIcon />}
                    text={t('chat_details.leave_group')}
                  />
                </DeleteConfirmationChild>
              </ChatOption>
            </Group>
          )}

          {initialContacts?.length > 0 && (
            <Group>
              <TitleWrapper>
                <h1>
                  {memberCount} {t('new_chat.members')}
                </h1>
              </TitleWrapper>
              <MembersList>
                <ContactElementChatDetails
                  item={user}
                  variant={user.id === user.id ? "me" : ""}
                  displayMenu={!isCallActive ? displayMenu : null}
                  isCurrentUserAdmin={isCurrentUserAdmin && !isCallActive}
                  isUserAdmin={checkIfUserIsAdmin(user)}
                />
                {initialContacts?.map((contact, index) => (
                  <ContactElementChatDetails
                    key={index}
                    item={contact}
                    variant={contact.id === user.id ? "me" : ""}
                    displayMenu={!isCallActive ? displayMenu : null}
                    isCurrentUserAdmin={isCurrentUserAdmin && !isCallActive}
                    isUserAdmin={checkIfUserIsAdmin(contact)}
                  />
                ))}
              </MembersList>

              <StyledMenu id={MENU_ID}>
                {filterButtons(buttonList).map((item, index) => {
                  if (item.withConfirmation) {
                    return (
                      <Item onClick={handleItemClick} id={item.id} key={index}>
                        <CustomItem onClick={handleItemClick} text={item.text} redButton={item.redButton} />
                      </Item>
                    );
                  } else {
                    return (
                      <Item onClick={handleItemClick} id={item.id} key={index}>
                        <CustomItem onClick={handleItemClick} text={item.text} redButton={item.redButton} />
                      </Item>
                    );
                  }
                })}
              </StyledMenu>
            </Group>
          )}

          <DeleteConfirmationChild
            setOpen={setRemoveUserConfirmation}
            open={removeUserConfirmation}
            action={handleRemoveMember}
            item={selectedMember}
            variant={selectedMember?.id === user.id ? "me" : ""}
          />

          <DeleteConfirmationChild
            setOpen={setRevokeAdminConfirmation}
            open={revokeAdminConfirmation}
            action={handleRevokeAdmin}
            item={selectedMember}
            variant={"revoke_admin"}
          />
        </>
      )}

      {option === NEW_CONTACT && (
        <Wrapper>
          <AddNewChatContact
            loadContacts={loadContacts}
            closeAction={handleCloseAddNewContact}
          />
        </Wrapper>
      )}
      
      {infoChanged && !isCallActive && (
        <Group>
          <PrimaryButton
            style={{ padding: "16px" }}
            onClick={() => handleUpdateCallChat()}
            text={t('general.save')}
          />
        </Group>
      )}
    </AddNewGroupContainer>
  );
};

export default CallChatDetailsView;

const AddNewGroupContainer = styled.div`
  background: ${({ theme }) => theme.menu.background};
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 25px;
  z-index: 1;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    color: ${({ theme }) => theme.menu.infoText};
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
`;

const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserAvatar = styled.div`
  display: flex;
  align-items: center;
  border-radius: 100px;
  cursor: pointer;
  max-height: 42px;
  max-width: 42px;
  min-width: 42px;
  min-height: 42px;
`;

const UserWrapper = styled.div`
  display: flex;
  gap: 10px;
  h1 {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
`;

const UserAvatarWrapper = styled.div`
  position: relative;
  gap: 3px;
  display: flex;
  flex-direction: column;
`;

const CustomInput = styled.input`
  margin-top: 10px;
  height: 24px;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.408px;
  &:focus-visible {
    outline: none;
  }
`;

const CustomNameInput = styled(CustomInput)`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  width: 100%;
  text-overflow: ellipsis;
  &:read-only {
    cursor: default;
  }
`;

const PreviewAvatar = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  height: 42px;
  width: 42px;
  overflow: hidden;
  border-radius: 100px;

  svg {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  img {
    object-fit: cover;
    position: relative;
    height: 43px;
    width: 43px;
  }
`;

const EditButton = styled.p`
  cursor: pointer;
  color: ${({ theme }) => theme.primaryButton.color};
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: -0.41px;
  text-align: center;
`;

const CallTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  display: flex;
  align-items: center;
`;

const ChatOption = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  border-bottom: 1px solid #363e5180;
  &:last-child {
    border: none;
  }
  h1 {
    min-width: 75px;
    color: #ffffff99;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.40799999237060547px;
  }
  h2 {
    text-transform: capitalize;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.40799999237060547px;
  }
`;

const Separator = styled.div`
  background: ${({ theme }) => theme.sidebar.borderColor};
  height: 1px;
  width: 100%;
`;

const MembersList = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  padding: 10px 16px;
  gap: 8px;
`;

const CustomItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: ${({ redButton, theme }) => (redButton ? colors.errorColor : theme.menu.primaryTextColor)};
  svg {
    height: 20px;
    width: 20px;
  }
`;

const StyledMenu = styled(Menu).attrs({})`
  background: ${({ theme }) => theme.menu.background};
  color: white;
  padding: 0;
  border-radius: 12px;

  .contexify_item {
    border-bottom: 0.5px solid ${({ theme }) => theme.sidebar.borderColor};
    padding: 6px 10px;
    &:last-child {
      border-bottom: none;
    }
  }
  .contexify_itemContent {
    color: ${colors.errorColor};
  }
  .contexify_item:not(.contexify_item-disabled):hover > .contexify_itemContent,
  .contexify_item:not(.contexify_item-disabled):focus > .contexify_itemContent {
    color: inherit;
    background-color: ${({ theme }) => theme.menu.selectedOpionBackground};
  }
`;

const Wrapper = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  overflow: auto;
  width: 100%;
  left: 0;
  background: ${colors.newChatModalBg};
  gap: 25px;
  display: flex;
  flex-direction: column;
`;